// URLs, sessionStorage keys, and copy for the 526 introduction and screener.
// Defined here instead of imported from all-claims/constants.js so importing
// them doesn't also pull in the full form schema. Keep these values equal to
// the matching exports in that file.

export const DISABILITY_526_V2_ROOT_URL =
  '/disability/file-disability-claim-form-21-526ez';

// sessionStorage key set when the screener has been completed.
export const WIZARD_STATUS = 'wizardStatus526';
// sessionStorage keys the screener sets from the separation date answer.
export const FORM_STATUS_BDD = 'formStatusBdd';
export const SAVED_SEPARATION_DATE = 'savedSeparationDate';

export const START_PATH = '/start';
export const GET_STARTED_PATH = '/get-started';
export const START_URL = `${DISABILITY_526_V2_ROOT_URL}${START_PATH}`;
export const GET_STARTED_URL = `${DISABILITY_526_V2_ROOT_URL}${GET_STARTED_PATH}`;
export const GET_STARTED_TITLE = 'Let us help you get started';

export const ELIGIBILITY_URL = '/disability/eligibility/';
export const EVIDENCE_NEEDED_URL =
  '/disability/how-to-file-claim/evidence-needed/';
export const LAY_STATEMENT_FORM_URL =
  'https://www.vba.va.gov/pubs/forms/vba-21-10210-are.pdf';
export const BDD_INFO_URL =
  '/disability/how-to-file-claim/when-to-file/pre-discharge-claim/';

export const OMB_CONTROL = '2900-0747';

// Public DBQs page that links to the Separation Health Assessment Part A.
export const DBQ_URL =
  'https://www.benefits.va.gov/compensation/dbq_publicdbqs.asp';

export const SHA_PART_A_PDF_URL =
  'https://www.benefits.va.gov/compensation/docs/SHA_DBQ_Part_A_Self-Assessment.pdf';

export const ITF_NOTICE_TEXT = `By starting the disability application, you'll declare your intent to file. This will reserve a potential effective date for when you could start getting benefits. You have 1 year from the day you submit your intent to file to complete your application.`;
